import { MDCRipple } from '@material/ripple';

// This function sets up the ripple effect for the various buttons throughout the
// theme using CSS selectors.
export const setupRippleEffect = rootElement => {
  if ('reduceAnimations' in document.body.dataset) { return; }

  const rippleElements = [
    '.button-primary',
    '.button-secondary',
    '.product-form--atc-button',
    '.mobile-nav-content .navmenu-link',
    '.mobile-nav-content .navmenu-button',
    '.live-search-button',
    '.form-options-selectable-boxes .option-value-name',
  ];

  rootElement.querySelectorAll(rippleElements.join(',')).forEach(el => {
    if (!el.classList.contains('disabled') && !el.hasAttribute('disabled')) {
      el.classList.add('mdc-ripple-surface');
      MDCRipple.attachTo(el);
    }
  });
};

export default {
  setupRippleEffect,
};
